import { SET_ADDCOMPANY } from '../actions';

const companyadd = (state = [], action) => {
  switch (action.type) {
	case SET_ADDCOMPANY:
      return [...action.value];  
    default: return state;
  }
}

export default companyadd;
